import { createFileRoute } from '@tanstack/react-router';
import TerminalDetailView from '../terminal/ManageTerminalsView/components/TerminalDetailView';
export const Route = createFileRoute('/terminals/locations/$terminalId')({
  component: TerminalDetailView,
});
